import React, {useState} from "react";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import ContactUsView from "../../views/ver_24.10/ContactUs.view";
import {submitContactUsRequest} from "../../services/misc.service";
import {toast} from "../../utils/utils";
import {TOAST_TYPES} from "../../utils/constants";

const ContactUs = () => {
    const [showLoader, setShowLoader] = useState(false);

    const data = {

    };

    const actions = {
        onSubmitAction: async (values) => {
            setShowLoader(true);
            try {
                const result = await submitContactUsRequest(values.name, values.email, values.message);
                if (result.data && result.data.success) {
                    toast(TOAST_TYPES.SUCCESS, "Successful", "Email sent and we will get back to you soon!")
                    console.log('Form Submitted:', values);
                }
            } catch (e) {
                // already toasted the error
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        }
    };

    const options = {

    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <ContactUsView data={data} actions={actions} options={options}/>
            </div>
        </>
    );

}

export default ContactUs;